export type ProcessingMode = 'copilot' | 'automatic';

/** Copiloto is the FREE mode; the automatic flow is PRO-only.
 *
 *  (This flipped in July 2026 — it used to be the other way around. Existing
 *  automatic-flow projects keep working; only NEW submissions are gated.)
 *
 *  Mirrored by the backend gate in `../autoclipper-backend`
 *  (`src/lib/resolveProcessingMode.js`), which coerces rather than rejects so
 *  legacy clients that still default to `automatic` degrade gracefully. */
export function resolveProcessingMode(
  { isPro, requested }: { isPro: boolean; requested?: string | null },
): { mode: ProcessingMode; automaticLocked: boolean } {
  if (!isPro) return { mode: 'copilot', automaticLocked: true };
  return { mode: requested === 'copilot' ? 'copilot' : 'automatic', automaticLocked: false };
}
